/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    Carriers,
    CarriersFromJSON,
    CarriersFromJSONTyped,
    CarriersToJSON,
    CodeAndLabel,
    CodeAndLabelFromJSON,
    CodeAndLabelFromJSONTyped,
    CodeAndLabelToJSON,
    DateTimeRestrictionData,
    DateTimeRestrictionDataFromJSON,
    DateTimeRestrictionDataFromJSONTyped,
    DateTimeRestrictionDataToJSON,
    FareBasisCode,
    FareBasisCodeFromJSON,
    FareBasisCodeFromJSONTyped,
    FareBasisCodeToJSON,
    FormDataRouteRestriction,
    FormDataRouteRestrictionFromJSON,
    FormDataRouteRestrictionFromJSONTyped,
    FormDataRouteRestrictionToJSON,
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
    Int32IdAndLabel,
    Int32IdAndLabelFromJSON,
    Int32IdAndLabelFromJSONTyped,
    Int32IdAndLabelToJSON,
    RuleFormDataAgencyOrGroup,
    RuleFormDataAgencyOrGroupFromJSON,
    RuleFormDataAgencyOrGroupFromJSONTyped,
    RuleFormDataAgencyOrGroupToJSON,
    SearchTravelRange,
    SearchTravelRangeFromJSON,
    SearchTravelRangeFromJSONTyped,
    SearchTravelRangeToJSON,
} from './';

/**
 * 
 * @export
 * @interface GlobalFilterFormData
 */
export interface GlobalFilterFormData {
    /**
     * 
     * @type {string}
     * @memberof GlobalFilterFormData
     */
    id?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GlobalFilterFormData
     */
    allowEdit?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GlobalFilterFormData
     */
    disabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GlobalFilterFormData
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GlobalFilterFormData
     */
    comment?: string | null;
    /**
     * 
     * @type {BrandAndMarketListItem}
     * @memberof GlobalFilterFormData
     */
    brandAndMarket?: BrandAndMarketListItem;
    /**
     * 
     * @type {number}
     * @memberof GlobalFilterFormData
     */
    relevance?: number;
    /**
     * 
     * @type {object}
     * @memberof GlobalFilterFormData
     */
    effectiveFrom?: object | null;
    /**
     * 
     * @type {object}
     * @memberof GlobalFilterFormData
     */
    effectiveTo?: object | null;
    /**
     * 
     * @type {boolean}
     * @memberof GlobalFilterFormData
     */
    allow?: boolean;
    /**
     * 
     * @type {Array<Int32IdAndLabel>}
     * @memberof GlobalFilterFormData
     */
    distributionChannels?: Array<Int32IdAndLabel> | null;
    /**
     * 
     * @type {Array<RuleFormDataAgencyOrGroup>}
     * @memberof GlobalFilterFormData
     */
    agenciesAndGroups?: Array<RuleFormDataAgencyOrGroup> | null;
    /**
     * 
     * @type {Array<FormDataRouteRestriction>}
     * @memberof GlobalFilterFormData
     */
    routes?: Array<FormDataRouteRestriction> | null;
    /**
     * 
     * @type {Array<CodeAndLabel>}
     * @memberof GlobalFilterFormData
     */
    salesJourneys?: Array<CodeAndLabel> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GlobalFilterFormData
     */
    marketingFlightNumbers?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof GlobalFilterFormData
     */
    marketingFlightNumbersMatch?: boolean | null;
    /**
     * 
     * @type {Array<GuidIdAndLabel>}
     * @memberof GlobalFilterFormData
     */
    providers?: Array<GuidIdAndLabel> | null;
    /**
     * 
     * @type {Array<FareBasisCode>}
     * @memberof GlobalFilterFormData
     */
    fareBases?: Array<FareBasisCode> | null;
    /**
     * 
     * @type {boolean}
     * @memberof GlobalFilterFormData
     */
    fareBasesMatch?: boolean | null;
    /**
     * 
     * @type {Array<CodeAndLabel>}
     * @memberof GlobalFilterFormData
     */
    fareTypes?: Array<CodeAndLabel> | null;
    /**
     * 
     * @type {Array<Carriers>}
     * @memberof GlobalFilterFormData
     */
    carriers?: Array<Carriers> | null;
    /**
     * 
     * @type {boolean}
     * @memberof GlobalFilterFormData
     */
    carriersMatch?: boolean | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GlobalFilterFormData
     */
    bookingClasses?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof GlobalFilterFormData
     */
    bookingClassesMatch?: boolean | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GlobalFilterFormData
     */
    accountCodes?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof GlobalFilterFormData
     */
    baglessFaresMatch?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof GlobalFilterFormData
     */
    doubleConnectionsMatch?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof GlobalFilterFormData
     */
    multiAirportConnectionsMatch?: boolean | null;
    /**
     * 
     * @type {object}
     * @memberof GlobalFilterFormData
     */
    maxConnectionTimeFrom?: object | null;
    /**
     * 
     * @type {object}
     * @memberof GlobalFilterFormData
     */
    maxConnectionTimeTo?: object | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GlobalFilterFormData
     */
    mixAndMatchProviders?: Array<string> | null;
    /**
     * 
     * @type {Array<DateTimeRestrictionData>}
     * @memberof GlobalFilterFormData
     */
    dateTimeRestrictions?: Array<DateTimeRestrictionData> | null;
    /**
     * 
     * @type {CodeAndLabel}
     * @memberof GlobalFilterFormData
     */
    dateTimeRestrictionsTimeZone?: CodeAndLabel;
    /**
     * 
     * @type {Array<SearchTravelRange>}
     * @memberof GlobalFilterFormData
     */
    travelDates?: Array<SearchTravelRange> | null;
    /**
     * 
     * @type {string}
     * @memberof GlobalFilterFormData
     */
    cloneSourceId?: string | null;
}

export function GlobalFilterFormDataFromJSON(json: any): GlobalFilterFormData {
    return GlobalFilterFormDataFromJSONTyped(json, false);
}

export function GlobalFilterFormDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GlobalFilterFormData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'allowEdit': !exists(json, 'allowEdit') ? undefined : json['allowEdit'],
        'disabled': !exists(json, 'disabled') ? undefined : json['disabled'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : BrandAndMarketListItemFromJSON(json['brandAndMarket']),
        'relevance': !exists(json, 'relevance') ? undefined : json['relevance'],
        'effectiveFrom': !exists(json, 'effectiveFrom') ? undefined : json['effectiveFrom'],
        'effectiveTo': !exists(json, 'effectiveTo') ? undefined : json['effectiveTo'],
        'allow': !exists(json, 'allow') ? undefined : json['allow'],
        'distributionChannels': !exists(json, 'distributionChannels') ? undefined : (json['distributionChannels'] === null ? null : (json['distributionChannels'] as Array<any>).map(Int32IdAndLabelFromJSON)),
        'agenciesAndGroups': !exists(json, 'agenciesAndGroups') ? undefined : (json['agenciesAndGroups'] === null ? null : (json['agenciesAndGroups'] as Array<any>).map(RuleFormDataAgencyOrGroupFromJSON)),
        'routes': !exists(json, 'routes') ? undefined : (json['routes'] === null ? null : (json['routes'] as Array<any>).map(FormDataRouteRestrictionFromJSON)),
        'salesJourneys': !exists(json, 'salesJourneys') ? undefined : (json['salesJourneys'] === null ? null : (json['salesJourneys'] as Array<any>).map(CodeAndLabelFromJSON)),
        'marketingFlightNumbers': !exists(json, 'marketingFlightNumbers') ? undefined : json['marketingFlightNumbers'],
        'marketingFlightNumbersMatch': !exists(json, 'marketingFlightNumbersMatch') ? undefined : json['marketingFlightNumbersMatch'],
        'providers': !exists(json, 'providers') ? undefined : (json['providers'] === null ? null : (json['providers'] as Array<any>).map(GuidIdAndLabelFromJSON)),
        'fareBases': !exists(json, 'fareBases') ? undefined : (json['fareBases'] === null ? null : (json['fareBases'] as Array<any>).map(FareBasisCodeFromJSON)),
        'fareBasesMatch': !exists(json, 'fareBasesMatch') ? undefined : json['fareBasesMatch'],
        'fareTypes': !exists(json, 'fareTypes') ? undefined : (json['fareTypes'] === null ? null : (json['fareTypes'] as Array<any>).map(CodeAndLabelFromJSON)),
        'carriers': !exists(json, 'carriers') ? undefined : (json['carriers'] === null ? null : (json['carriers'] as Array<any>).map(CarriersFromJSON)),
        'carriersMatch': !exists(json, 'carriersMatch') ? undefined : json['carriersMatch'],
        'bookingClasses': !exists(json, 'bookingClasses') ? undefined : json['bookingClasses'],
        'bookingClassesMatch': !exists(json, 'bookingClassesMatch') ? undefined : json['bookingClassesMatch'],
        'accountCodes': !exists(json, 'accountCodes') ? undefined : json['accountCodes'],
        'baglessFaresMatch': !exists(json, 'baglessFaresMatch') ? undefined : json['baglessFaresMatch'],
        'doubleConnectionsMatch': !exists(json, 'doubleConnectionsMatch') ? undefined : json['doubleConnectionsMatch'],
        'multiAirportConnectionsMatch': !exists(json, 'multiAirportConnectionsMatch') ? undefined : json['multiAirportConnectionsMatch'],
        'maxConnectionTimeFrom': !exists(json, 'maxConnectionTimeFrom') ? undefined : json['maxConnectionTimeFrom'],
        'maxConnectionTimeTo': !exists(json, 'maxConnectionTimeTo') ? undefined : json['maxConnectionTimeTo'],
        'mixAndMatchProviders': !exists(json, 'mixAndMatchProviders') ? undefined : json['mixAndMatchProviders'],
        'dateTimeRestrictions': !exists(json, 'dateTimeRestrictions') ? undefined : (json['dateTimeRestrictions'] === null ? null : (json['dateTimeRestrictions'] as Array<any>).map(DateTimeRestrictionDataFromJSON)),
        'dateTimeRestrictionsTimeZone': !exists(json, 'dateTimeRestrictionsTimeZone') ? undefined : CodeAndLabelFromJSON(json['dateTimeRestrictionsTimeZone']),
        'travelDates': !exists(json, 'travelDates') ? undefined : (json['travelDates'] === null ? null : (json['travelDates'] as Array<any>).map(SearchTravelRangeFromJSON)),
        'cloneSourceId': !exists(json, 'cloneSourceId') ? undefined : json['cloneSourceId'],
    };
}

export function GlobalFilterFormDataToJSON(value?: GlobalFilterFormData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'allowEdit': value.allowEdit,
        'disabled': value.disabled,
        'description': value.description,
        'comment': value.comment,
        'brandAndMarket': BrandAndMarketListItemToJSON(value.brandAndMarket),
        'relevance': value.relevance,
        'effectiveFrom': value.effectiveFrom,
        'effectiveTo': value.effectiveTo,
        'allow': value.allow,
        'distributionChannels': value.distributionChannels === undefined ? undefined : (value.distributionChannels === null ? null : (value.distributionChannels as Array<any>).map(Int32IdAndLabelToJSON)),
        'agenciesAndGroups': value.agenciesAndGroups === undefined ? undefined : (value.agenciesAndGroups === null ? null : (value.agenciesAndGroups as Array<any>).map(RuleFormDataAgencyOrGroupToJSON)),
        'routes': value.routes === undefined ? undefined : (value.routes === null ? null : (value.routes as Array<any>).map(FormDataRouteRestrictionToJSON)),
        'salesJourneys': value.salesJourneys === undefined ? undefined : (value.salesJourneys === null ? null : (value.salesJourneys as Array<any>).map(CodeAndLabelToJSON)),
        'marketingFlightNumbers': value.marketingFlightNumbers,
        'marketingFlightNumbersMatch': value.marketingFlightNumbersMatch,
        'providers': value.providers === undefined ? undefined : (value.providers === null ? null : (value.providers as Array<any>).map(GuidIdAndLabelToJSON)),
        'fareBases': value.fareBases === undefined ? undefined : (value.fareBases === null ? null : (value.fareBases as Array<any>).map(FareBasisCodeToJSON)),
        'fareBasesMatch': value.fareBasesMatch,
        'fareTypes': value.fareTypes === undefined ? undefined : (value.fareTypes === null ? null : (value.fareTypes as Array<any>).map(CodeAndLabelToJSON)),
        'carriers': value.carriers === undefined ? undefined : (value.carriers === null ? null : (value.carriers as Array<any>).map(CarriersToJSON)),
        'carriersMatch': value.carriersMatch,
        'bookingClasses': value.bookingClasses,
        'bookingClassesMatch': value.bookingClassesMatch,
        'accountCodes': value.accountCodes,
        'baglessFaresMatch': value.baglessFaresMatch,
        'doubleConnectionsMatch': value.doubleConnectionsMatch,
        'multiAirportConnectionsMatch': value.multiAirportConnectionsMatch,
        'maxConnectionTimeFrom': value.maxConnectionTimeFrom,
        'maxConnectionTimeTo': value.maxConnectionTimeTo,
        'mixAndMatchProviders': value.mixAndMatchProviders,
        'dateTimeRestrictions': value.dateTimeRestrictions === undefined ? undefined : (value.dateTimeRestrictions === null ? null : (value.dateTimeRestrictions as Array<any>).map(DateTimeRestrictionDataToJSON)),
        'dateTimeRestrictionsTimeZone': CodeAndLabelToJSON(value.dateTimeRestrictionsTimeZone),
        'travelDates': value.travelDates === undefined ? undefined : (value.travelDates === null ? null : (value.travelDates as Array<any>).map(SearchTravelRangeToJSON)),
        'cloneSourceId': value.cloneSourceId,
    };
}


